// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option-desc .option-warning-icon[data-v-6db08236] {\n  margin-top: -2px;\n  margin-right: 3px;\n}\n.option-desc .option-title-warning[data-v-6db08236] {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 80%;\n}\n.option-desc .warning-label[data-v-6db08236] {\n  color: #ff811c;\n}\n", ""]);
// Exports
module.exports = exports;
